import { Component, Input, TemplateRef, ViewChild } from '@angular/core';

@Component({
    selector: 'lib-checkbox-group-item [value]',
    templateUrl: 'form-field-checkbox-group-item.html'
})
export class FormFieldCheckboxGroupItemComponent<T> {
    @Input() value!: T;
    @Input() disabled: boolean = false;
    @Input() qaTag: string = "";

    @ViewChild('checkboxLabel', {static: true, read: TemplateRef}) label!: TemplateRef<any>;
    @ViewChild('checkboxSupportingText', {static: true, read: TemplateRef}) supportingText!: TemplateRef<any>;
}
